export default class MobileNavbar {
    static init(): void {
        const headerNavbars = document.querySelectorAll('.header-navbar');

        headerNavbars.forEach((headerNavbar) => {
            const navbarDropdownToggles = headerNavbar.querySelectorAll('.navbar-dropdown-toggle') as NodeListOf<HTMLElement>;

            navbarDropdownToggles.forEach((toggle) => {
                toggle.addEventListener('mouseover', () => {
                    const menus = toggle.closest('.header-navbar')?.querySelectorAll('.navbar-dropdown-menu') as NodeListOf<HTMLElement>;
                    menus.forEach((menu) => {
                        menu.classList.remove('navbar-dropdown-menu--show');
                    });
                    this.showDropdownMenu(toggle);
                });
            });

            const navbarLinks = headerNavbar.querySelectorAll('.nav-link') as NodeListOf<HTMLElement>;
            navbarLinks.forEach((item) => {
                item.addEventListener('mouseenter', () => {
                    if (item.classList.contains('nav-link--dropdown') || item.classList.contains('navbar-dropdown-toggle')) return;
                    const menus = item.closest('.header-navbar')?.querySelectorAll('.navbar-dropdown-menu') as NodeListOf<HTMLElement>;
                    menus.forEach((menu) => {
                        menu.classList.remove('navbar-dropdown-menu--show');
                    });
                });
            });

        });

        document.addEventListener('mousemove', (event) => {
            const target = event.target as HTMLElement;
            if (!target.closest('.header-navbar')) {
                const dropdownToggles = document.querySelectorAll('.header-navbar .navbar-dropdown-toggle') as NodeListOf<HTMLElement>;
                dropdownToggles.forEach((toggle) => {
                    const dropdownMenu = toggle.nextElementSibling as HTMLElement | null;

                    if (dropdownMenu && dropdownMenu.classList.contains('navbar-dropdown-menu')) {
                        dropdownMenu.classList.remove('navbar-dropdown-menu--show');
                        toggle.classList.remove('navbar-dropdown-toggle--active');
                    }

                });
            }
        });
    }

    static showDropdownMenu(toggle: HTMLElement): void {
        const dropdownMenu = toggle.nextElementSibling as HTMLElement | null;
        if (dropdownMenu && dropdownMenu.classList.contains('navbar-dropdown-menu')) {
            const headerNavbar = toggle.closest('.header-navbar') as HTMLElement;
            // nastavit polohu dropdownMenu podle pozice toggle v relativním rodiči
            const toggleRect = toggle.getBoundingClientRect();
            const headerNavbarRect = headerNavbar.getBoundingClientRect();
            dropdownMenu.style.left = `${toggleRect.left - headerNavbarRect.left}px`;
            dropdownMenu.style.top = `${toggleRect.bottom - headerNavbarRect.top}px`;
            // vycentrovat dropdownMenu na střed toggle
            const toggleWidth = toggleRect.width;
            const dropdownMenuWidth = dropdownMenu.offsetWidth;
            dropdownMenu.style.left = `${toggleRect.left - headerNavbarRect.left + (toggleWidth - dropdownMenuWidth) / 2}px`;

            dropdownMenu.classList.add('navbar-dropdown-menu--show');
            toggle.classList.add('navbar-dropdown-toggle--active');
        }
    }
}
